import React, { useEffect, useState, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  addANewJob,
  adminActions,
  fetchCustomer,
  signOut,
} from "../store/adminSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import HeaderScaff from "../components/HeaderScaff";
import escapeHtml from "../functions/Validator";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DescriptionIcon from "@mui/icons-material/Description";
import BuildIcon from "@mui/icons-material/Build";
import ImageIcon from "@mui/icons-material/Image";

function AddANewJob() {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [needed, setNeeded] = useState(false);
  const dispatch = useDispatch();
  const newCustomer = useSelector((state) => state.admin.newCustomer);
  const [selectedImages, setSelectedImages] = useState([]);
  const stateSwalAlert = useSelector((state) => state.admin.swalAlert);
  const [documents, setDocument] = useState([]);
  const _id = useSelector((state) => state.admin._id);
  const [data, setData] = useState({
    customer: "",
    job1: "",
    job2: "",
    postCode: "",
    jobDescription: "",
    jobDetails: "",
    scafolldingType: "",
  });
  const [postcodeSuggestions, setPostcodeSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [postcodeLoading, setPostcodeLoading] = useState(false);
  const debounceTimer = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const subscribed = useSelector((state) => state.admin.subscribed);
  const statesignOut = useSelector((state) => state.admin.signOut);

  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);

  useEffect(() => {
    dispatch(adminActions.removeSwalAlert());
    dispatch(fetchCustomer({ adminID: _id }));
  }, []);

  useEffect(() => {
    if (!_id) {
      navigate("/signin");
    } else if (!subscribed) {
      navigate("/signin");
    }
  }, []);

  // Postcode autocomplete function with debouncing
  const searchPostcode = async (query) => {
    if (query.length < 2) {
      setPostcodeSuggestions([]);
      setShowSuggestions(false);
      setPostcodeLoading(false);
      return;
    }

    try {
      setPostcodeLoading(true);
      const response = await fetch(`/admin/postcode?code=${query.toUpperCase()}`);
      const result = await response.json();
      
      if (result.success && result.data && Array.isArray(result.data)) {
        // Convert string array to objects for consistent UI
        const suggestions = result.data.map(postcode => ({
          postcode: postcode,
          district: null // API doesn't provide district info
        }));
        setPostcodeSuggestions(suggestions);
        setShowSuggestions(true);
      } else {
        setPostcodeSuggestions([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      console.error('Postcode search error:', error);
      setPostcodeSuggestions([]);
      setShowSuggestions(false);
    } finally {
      setPostcodeLoading(false);
    }
  };

  const handlePostcodeChange = (e) => {
    const value = e.target.value;
    setData({ ...data, postCode: value });

    // Clear existing timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Clear suggestions if input is empty
    if (value.length === 0) {
      setPostcodeSuggestions([]);
      setShowSuggestions(false);
      setPostcodeLoading(false);
      return;
    }

    // Set new timer for debounced search
    if (value.length >= 2) {
      setPostcodeLoading(true);
      debounceTimer.current = setTimeout(() => {
        searchPostcode(value);
      }, 1000); // 1 second delay
    }
  };

  const selectPostcode = (suggestion) => {
    setData({ ...data, postCode: suggestion.postcode });
    setShowSuggestions(false);
    setPostcodeSuggestions([]);
    setPostcodeLoading(false);
    
    // Clear any pending timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
  };

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  const imageHandler = (e) => {
    const files = Array.from(e.target.files);
    setDocument(prev => [...prev, ...files]);

    const fileArray = files.map((file) =>
      URL.createObjectURL(file)
    );

    setSelectedImages((prevImage) => prevImage.concat(fileArray));
  };

  const removeImage = (index) => {
    const newSelectedImages = [...selectedImages];
    newSelectedImages.splice(index, 1);
    setSelectedImages(newSelectedImages);
    
    const newDocuments = Array.from(documents);
    newDocuments.splice(index, 1);
    setDocument(newDocuments);
  };

  const renderPhotos = (source) => {
    return source.map((photo, index) => {
      return (
        <div key={index} className="relative group">
          <button 
            onClick={() => removeImage(index)}
            className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 rounded-full p-1 text-white z-10 transition-colors opacity-0 group-hover:opacity-100"
          >
            <CloseIcon fontSize="small" />
          </button>
          <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-lightgreen transition-colors">
            <img
              className="w-full h-full object-cover"
              src={photo}
              alt="Job"
            />
          </div>
        </div>
      );
    });
  };

  useEffect(() => {
    if (stateSwalAlert === "added") {
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Success",
        confirmButtonColor: "#60c088",
        text: "Job Added Successfully!",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
        window.location.reload(true);
      });
    }
  }, [stateSwalAlert]);

  const submit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (
      data.customer === "" ||
      data.job1 === "" ||
      data.postCode === "" ||
      data.jobDescription === "" ||
      data.jobDetails === "" ||
      documents.length === 0 ||
      data.scafolldingType === ""
    ) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Incomplete Form",
        confirmButtonColor: "#60c088",
        text: "Please fill all fields and upload at least one image.",
      });
    } else {
      const formData = new FormData();
      for (let i = 0; i < documents.length; i++) {
        formData.append("images", documents[i]);
      }
      formData.append("customer", data.customer);
      formData.append("job1", data.job1);
      formData.append("job2", data.job2);
      formData.append("postCode", data.postCode);
      formData.append("jobDescription", data.jobDescription);
      formData.append("jobDetails", data.jobDetails);
      formData.append("typeofScafollding", data.scafolldingType);
      formData.append("adminID", _id);
      
      dispatch(addANewJob(formData));

      Swal.fire({
        icon: "success",
        title: "Saved",
        confirmButtonColor: "#60c088",
      });
      navigate("/liveprojects");
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("firstLoad")) {
      localStorage["firstLoad"] = true;
    } else {
      localStorage.removeItem("firstLoad");
    }
    if (!isNonMobile) {
      setSidebarOpen(false);
    }
  }, []);

  return (
    <div className="w-full h-full bg-gray-50">
      <HeaderScaff />
      <div className={`w-full flex ${!isNonMobile && !sidebarOpen ? "flex-col" : ""} h-auto p-2 sm:p-6`}>
        <div className={`${sidebarOpen ? (isNonMobile ? "basis-1/5" : "flex justify-center w-full") : "hidden"} w-full h-full`}>
          <Sidebar
            setSidebarOpen={setSidebarOpen}
            needed={needed}
            isNonMobile={isNonMobile}
          />
        </div>

        <div
          onClick={() => setSidebarOpen(true)}
          className={`${sidebarOpen ? (isNonMobile ? "hidden" : "hidden") : (isNonMobile ? "flex w-12 mt-4" : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center")} h-fit`}
        >
          <div className={`${sidebarOpen ? (isNonMobile ? "" : "") : (isNonMobile ? "" : "hidden")}`}>
            <IconButton onClick={() => setSidebarOpen(true)}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
          <div className={`${sidebarOpen ? (isNonMobile ? "hidden" : "hidden") : (isNonMobile ? "hidden" : "flex")}`}>
            <p className="text-gray-500 text-xs py-[2px]">Sidebar</p>
          </div>
        </div>

        <div
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "basis-4/5 flex flex-col ml-4 md:pt-4"
                : "hidden"
              : "w-full flex flex-col pl-3 pt-3"
          }`}
        >
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-2">Add New Job</h1>
            <p className="text-gray-600">Create a new scaffolding job by filling out the form below</p>
          </div>

          <form onSubmit={submit} className="space-y-6">
            {/* Customer & Location Section */}
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
              <div className="flex items-center space-x-2 mb-4">
                <BusinessIcon className="text-lightgreen" />
                <h2 className="text-lg font-semibold text-gray-800">Customer & Location</h2>
              </div>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Customer Selection */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Select Customer *
                  </label>
                <select
                    value={data.customer}
                    onChange={(e) => setData({ ...data, customer: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lightgreen focus:border-lightgreen transition-colors bg-white"
                    required
                >
                    <option value="">Choose a customer...</option>
                    {newCustomer.map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.customerCompanyName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Scaffolding Type */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Type of Scaffolding *
                  </label>
                  <select
                    value={data.scafolldingType}
                    onChange={(e) => setData({ ...data, scafolldingType: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lightgreen focus:border-lightgreen transition-colors bg-white"
                    required
                  >
                    <option value="">Select type...</option>
                    <option value="0">Scaffolding</option>
                    <option value="1">Temporary Roof</option>
                </select>
                </div>

                {/* Address Line 1 */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Address Line 1 *
                  </label>
                <input
                    type="text"
                  value={data.job1}
                    onChange={(e) => setData({ ...data, job1: escapeHtml(e.target.value) })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lightgreen focus:border-lightgreen transition-colors"
                    placeholder="Enter street address"
                  required
                />
                </div>

                {/* Address Line 2 */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Address Line 2
                  </label>
                <input
                    type="text"
                  value={data.job2}
                    onChange={(e) => setData({ ...data, job2: escapeHtml(e.target.value) })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lightgreen focus:border-lightgreen transition-colors"
                    placeholder="Apartment, suite, etc. (optional)"
                />
                </div>

                {/* Postcode with Autocomplete */}
                <div className="space-y-2 relative">
                  <label className="block text-sm font-medium text-gray-700">
                    Postcode *
                  </label>
                  <div className="relative">
                <input
                      type="text"
                  value={data.postCode}
                      onChange={handlePostcodeChange}
                      onFocus={() => data.postCode.length >= 2 && setShowSuggestions(true)}
                      onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lightgreen focus:border-lightgreen transition-colors"
                      placeholder="Enter postcode"
                  required
                    />
                    
                    {/* Loading indicator */}
                    {postcodeLoading && (
                      <div className="absolute right-3 top-1/2 -translate-y-1/2">
                        <CircularProgress size={16} className="text-lightgreen" />
                      </div>
                    )}
                  </div>
                  
                  {/* Postcode Suggestions */}
                  {showSuggestions && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-40 overflow-y-auto">
                      {postcodeLoading ? (
                        <div className="flex items-center justify-center py-4">
                          <CircularProgress size={20} className="text-lightgreen mr-2" />
                          <span className="text-sm text-gray-500">Searching postcodes...</span>
                        </div>
                      ) : postcodeSuggestions.length > 0 ? (
                        postcodeSuggestions.map((suggestion, index) => (
                          <button
                            key={index}
                            type="button"
                            onClick={() => selectPostcode(suggestion)}
                            className="w-full px-3 py-2 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
                          >
                            <div className="font-medium">{suggestion.postcode}</div>
                            {suggestion.district && (
                              <div className="text-sm text-gray-500">{suggestion.district}</div>
                            )}
                          </button>
                        ))
                      ) : data.postCode.length >= 2 && !postcodeLoading ? (
                        <div className="px-3 py-2 text-sm text-gray-500">
                          No postcodes found for "{data.postCode}"
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Job Details Section */}
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
              <div className="flex items-center space-x-2 mb-4">
                <DescriptionIcon className="text-lightgreen" />
                <h2 className="text-lg font-semibold text-gray-800">Job Details</h2>
              </div>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Job Description */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Job Description *
                  </label>
                <textarea
                  value={data.jobDescription}
                    onChange={(e) => setData({ ...data, jobDescription: escapeHtml(e.target.value) })}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lightgreen focus:border-lightgreen transition-colors resize-none"
                    placeholder="Describe the scaffolding work required..."
                    required
                  />
                </div>

                {/* Access Details */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Access Details *
                  </label>
                  <textarea
                    value={data.jobDetails}
                    onChange={(e) => setData({ ...data, jobDetails: escapeHtml(e.target.value) })}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lightgreen focus:border-lightgreen transition-colors resize-none"
                    placeholder="Provide access instructions, parking details, contact information..."
                    required
                  />
                </div>
              </div>
            </div>

            {/* Images Section */}
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
              <div className="flex items-center space-x-2 mb-4">
                <ImageIcon className="text-lightgreen" />
                <h2 className="text-lg font-semibold text-gray-800">Job Images</h2>
          </div>
              
              <div className="space-y-4">
                {/* Upload Button */}
                <div className="flex items-center justify-between">
                  <p className="text-sm text-gray-600">Upload images of the job site (required)</p>
                  <label className="inline-flex items-center space-x-2 px-4 py-2 bg-lightgreen hover:bg-darkgreen text-white rounded-md cursor-pointer transition-colors">
                    <AddPhotoAlternateIcon fontSize="small" />
                    <span>Add Photos</span>
              <input
                type="file"
                multiple
                      accept="image/*"
                onChange={imageHandler}
                className="hidden"
              />
            </label>
                </div>

                {/* Image Grid */}
                {selectedImages.length > 0 && (
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                    {renderPhotos(selectedImages)}
                  </div>
                )}

                {selectedImages.length === 0 && (
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                    <AddPhotoAlternateIcon className="text-gray-400 mb-2" style={{ fontSize: 48 }} />
                    <p className="text-gray-500">No images uploaded yet</p>
                    <p className="text-sm text-gray-400">Click "Add Photos" to upload images</p>
                  </div>
                )}
              </div>
            </div>

            {/* Submit Section */}
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
              <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
                <div className="text-sm text-gray-600">
                  <p>* Required fields</p>
                  <p>Please review all information before submitting</p>
                </div>
                
                <div className="flex space-x-3">
                  <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
                  >
                    Reset Form
                  </button>
                  
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
                  >
              {loading ? (
                <>
                        <CircularProgress size={16} color="inherit" />
                        <span>Submitting...</span>
                </>
              ) : (
                      <>
                        <BuildIcon fontSize="small" />
                        <span>Create Job</span>
                      </>
                    )}
                </button>
                </div>
            </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddANewJob;
